export type Universe = 'WOMAN' | 'MAN' | 'KID';

export const normalizeUniverse = (universe?: string): Universe => {
  const upper = universe?.toUpperCase();
  if (upper === 'KIDS') return 'KID';
  if (upper === 'WOMAN' || upper === 'MAN' || upper === 'KID') return upper;
  return 'WOMAN';
};
